import React, { Component } from 'react'
import stylesecond from './second.module.css'
import {Card, Container,Row,Col,Button} from 'react-bootstrap'
import {connect} from 'react-redux';
import * as actionTypes from '../../../../Action/Index';
import {Spinner} from 'react-bootstrap';
 class Second extends Component {
     
  resendLink=()=>{
   let email2=this.props.email;
   this.props.interviewerSendEmail(email2);
  }

    render() {
        let x=this.props.show?stylesecond.secondOpen:stylesecond.secondClose;
        return (
            <Container className={`${stylesecond.maindiv} ${x}`}>
            <Card>
            <Card.Body>
            <Row>
                 <Col><h3 className={stylesecond.heading2}>Forgot Password</h3></Col>
            </Row>
           
     <Row>
     <span className={stylesecond.spinner}>{this.props.loader?<Spinner animation="border" variant="warning" />:
     <>
      <Col className={stylesecond.paragraph2}>
         <span className={stylesecond.successtext}>We have sent a reset password link to your Email ID.</span>
      </Col>
      </>}</span>
     </Row>
     <Row>
       <Col><Button variant="warning" disabled={this.props.loader} className={stylesecond.sendLink2} onClick={()=>{this.props.closedModal(); this.props.onResetLinkChangeState()}}>OK</Button></Col>
    </Row>
 
    <Row>
       <Col>Didn't receive a link? <button className={stylesecond.resend} onClick={()=>this.resendLink()} disabled={this.props.loader}> Resend</button>
       
       </Col>
       
    </Row>
     
            </Card.Body>
          </Card>

                
            </Container>
        )
    }
}

const mapStateToProps = state => {
  return{
    passwordResetLinkSent: state.employeeReducer.emailLinkSentSuccess,
    errorMsg: state.employeeReducer.resetLinkErrorMsg,
    loader: state.employeeReducer.emailLinkSentLoader,
    email:state.employeeReducer.emailForgot,
    resend:state.employeeReducer.resend
  }
}

const mapDispatchToProps = dispatch => {
  return{
    interviewerSendEmail:(email)=>dispatch(actionTypes.interviewerForgotPassword(email,2)),
    onResetLinkChangeState:()=>dispatch(actionTypes.changeResetLinkState())
  }
}
  

export default connect(mapStateToProps, mapDispatchToProps)(Second)
